import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-puzzle-icon',
  templateUrl: './code-puzzle.component.html'
})
export class CodePuzzleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
